module.exports = __webpack_public_path__ + "img/Alternatives-Alternative assessment.3c836faa.svg";